export default function VideoHeader({ youtubeId }) {
  return (
    <iframe
      title="Cover Video"
      className="tw-w-full tw-rounded-xl -tw-mb-2"
      height={500}
      src={`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&modestbranding=1&rel=0`}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
}
